import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { Typography, Button } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import LocaleMessage from '~/components/LocaleMessage';

import { getCleaningReportRobotErrorMsgKey } from '../CleaningReportsDashboard/cleaningReportUtils';

export default function CleaningReportPluginspaceRobotErrorsAlert({
    robots_errors,
}) {
    const groupedErrors = useMemo(() => {
        if (!robots_errors) return [];
        const groups = {};
        robots_errors.forEach(err => {
            const msgKey = getCleaningReportRobotErrorMsgKey(err.code);
            const groupKey = msgKey || err.error || err.code || 'unknown';
            if (!groups[groupKey]) {
                groups[groupKey] = {
                    msgKey,
                    code: err.code,
                    error: err.error,
                    robots: [],
                };
            }
            groups[groupKey].robots.push(err);
        });
        return Object.values(groups);
    }, [robots_errors]);

    if (!robots_errors || robots_errors.length === 0) {
        return null;
    }

    return (
        <Alert severity="warning" className="mb-3">
            <Typography variant="subtitle2" gutterBottom>
                <LocaleMessage msg="page.robots.cleaning_report.live.partial_errors_title" />
            </Typography>
            <div className="mb-0">
                {groupedErrors.map((group, idx) => (
                    <div key={idx} className="mb-2">
                        <Typography variant="body2" style={{ fontWeight: 500 }}>
                            {group.msgKey ? (
                                <LocaleMessage msg={group.msgKey} />
                            ) : (
                                <>
                                    <FormattedMessage
                                        id="page.robots.cleaning_report.robot_error.unlisted"
                                        values={{
                                            code: group.code || '—',
                                        }}
                                    />
                                    {group.error ? ` — ${group.error}` : ''}
                                </>
                            )}
                        </Typography>
                        <ul className="mb-0 pl-3">
                            {group.robots.map((err, i) => (
                                <li key={`${err.robot_uid || i}-${i}`}>
                                    <strong>
                                        {err.robot_name || err.robot_uid}
                                    </strong>
                                    {err.robot_code
                                        ? ` (${err.robot_code})`
                                        : ''}
                                    {err.robot_uid && (
                                        <Button
                                            variant="text"
                                            color="primary"
                                            size="small"
                                            component={Link}
                                            to={`/robots/${err.robot_uid}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="ml-2"
                                            style={{
                                                minWidth: 'auto',
                                                padding: '0 4px',
                                                fontSize: '0.75rem',
                                            }}
                                        >
                                            <LocaleMessage msg="button.check_robot" />
                                        </Button>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </Alert>
    );
}
